import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import MessagingChannelsComponent from './messaging/messaging-channels-component';
import MessagingMessagesComponent from './messaging/messaging-messages-component';

import { sendMessageNotification } from './actions'
import { getMessagingAccessToken } from '../actions';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class MessagingContainerComponent extends PureComponent {
  messagesEnd = null
  channelFetchTimeout = null
  constructor(props) {
    super(props);
    this.state = {
      componentInitialized: false,
      fetchingChannels: false,
      currentChannel: null,
      channels: [],
      messages: [],
      width: window.innerWidth
    }

    this.addMessage = this.addMessage.bind(this);
    this.renewAccessToken = this.renewAccessToken.bind(this);
    this.messageOnSubmit = this.messageOnSubmit.bind(this);
    this.addChatChannel = this.addChatChannel.bind(this);
    this.joinChannel = this.joinChannel.bind(this);
    this.clearCurrentChannel = this.clearCurrentChannel.bind(this);
    this.initializeChatChannels = this.initializeChatChannels.bind(this);
  }

  componentWillMount() {
    //If messaging token has already exists attempt to use it
    let messagingToken = this.props.dashboard.messagingToken;
    let messagingClient = this.props.dashboard.messagingClient;
    if (messagingToken && messagingClient) { this.initializeChatClient(messagingClient); }
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    //Make sure all listeners have been removed
    if (this.state.currentChannel) {
      this.state.currentChannel.removeListener('messageAdded', this.addMessage);
    }

    if (this.state.messagingClient) {
      this.state.messagingClient.removeListener('tokenAboutToExpire', this.renewAccessToken);
      this.state.messagingClient.removeListener("channelAdded", this.addChatChannel);
      this.state.messagingClient.removeListener("connectionStateChanged", this.initializeChatChannels);
    }
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidUpdate(oldProps) {
    if (this.props.dashboard.messagingToken
      && this.props.dashboard.messagingClient
      && !this.state.componentInitialized) {
      this.initializeChatClient(this.props.dashboard.messagingClient);
    }
  }

  //INITIALIZE CHAT
  initializeChatClient(client) {
    client.addListener("channelAdded", this.addChatChannel);
    client.addListener("tokenAboutToExpire", this.renewAccessToken);
    client.addListener("connectionStateChanged", this.initializeChatChannels);
    this.setState({ componentInitialized: true })
    this.initializeChatChannels(client);
  }
  //RENEW ACCESS TOKEN
  renewAccessToken() {
    this.props.dispatch(getMessagingAccessToken());
  }
  //INITIALIZE CHANNELS
  initializeChatChannels(client = null) {
    if (!client || client.connectionState !== 'connected') {
      let self = this;
      if (self.channelFetchTimeout) { return; }
      self.channelFetchTimeout = setTimeout(() => { self.initializeChatChannels(client) }, 1000);
      return;
    }

    let subscribedChannelPromise = client.getSubscribedChannels();
    if (subscribedChannelPromise) {
      subscribedChannelPromise.then(_channels => {
        this.setState({ channels: _channels.items ? _channels.items : _channels })
      }).catch(e => console.log(e))
    }
  }
  //CHANNEL - ADDED TO CHANNEL
  addChatChannel(channel) {
    let { channels } = this.state;
    channels.push(channel);
    this.setState({ channels: channels.slice(0) })
  }

  joinChannel(channelId) {
    let { currentChannel } = this.state;
    let messagingClient = this.props.dashboard.messagingClient;
    //if trying to join the same channel; get out
    if (currentChannel && currentChannel.uniqueName === channelId) return;
    //if already in a channel; leave first
    this.clearCurrentChannel();
    messagingClient.getChannelByUniqueName(channelId).then(channelToJoin => {
      this.setCurrentChannel(channelToJoin);
    }, error => {
    })
  }

  setCurrentChannel(channel) {
    this.setState({
      currentChannel: channel
    });
    channel.addListener('messageAdded', this.addMessage)
    channel.getMessages(25).then(messages => {
      this.setState({
        messages: messages.items
      });
    })
    channel.updateLastConsumedMessageIndex(channel.lastMessage.index).then(v => true);
  }

  clearCurrentChannel() {
    let { currentChannel } = this.state;
    if (!currentChannel) return;
    currentChannel.removeListener('messageAdded', this.addMessage)
    this.setState({
      currentChannel: null,
      messages: []
    });
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  addMessage(message) {
    let { currentChannel } = this.state;
    let messages = this.state.messages.slice(0);
    messages.push(message);
    this.setState({
      messages: messages
    });
    currentChannel.updateLastConsumedMessageIndex(message.index).then(v => {/*console.log(v)*/ });
  }

  messageOnSubmit(values, { resetForm }) {
    let { dispatch } = this.props;
    if (!values.message) { return; }
    this.state.currentChannel.sendMessage(values.message);
    resetForm({ message: '' });
    dispatch(sendMessageNotification(values.notifyUserId));
  }

  render() {
    let { channels, currentChannel, messages, width } = this.state;
    let { user, messagingClient } = this.props.dashboard;
    let isMobile = width <= 576;
    if (!messagingClient) { return (<div className="container text-center"><h4>Loading...</h4></div>); }
    if (!isMobile)
      return (<div className="container messaging-container">
        <div className="row">
          <MessagingChannelsComponent
            channels={channels}
            currentChannel={currentChannel}
            user={user}
            onClick={this.joinChannel} />
          <MessagingMessagesComponent
            currentChannel={currentChannel}
            messages={messages}
            user={user}
            onSubmit={this.messageOnSubmit}
            isMobile={isMobile} />
        </div>
      </div>);
    else
      return (<div className="container messaging-container message-messages-mobile">
        <div className="row">
          {!currentChannel
            ? (<MessagingChannelsComponent
              channels={channels}
              currentChannel={currentChannel}
              user={user}
              onClick={this.joinChannel} />)
            : (<MessagingMessagesComponent
              currentChannel={currentChannel}
              messages={messages}
              user={user}
              onSubmit={this.messageOnSubmit}
              onBack={this.clearCurrentChannel}
              isMobile={isMobile} />)
          }
        </div>
      </div>)

  }
}

export default withRouter(connect(mapStateToProps)(MessagingContainerComponent));
